import { render } from "./VolnePozice.vue?vue&type=template&id=01c22d06"
import script from "./VolnePozice.vue?vue&type=script&lang=js"
export * from "./VolnePozice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__